/** Build-time identity of this deployment; empty on local builds and wherever the define does not exist, such as the test runner. */
export const DEPLOY = {
	sha: typeof __PANDAS_DEPLOY_SHA__ === "undefined" ? "" : __PANDAS_DEPLOY_SHA__.slice(0, 12),
	deploymentId: typeof __PANDAS_DEPLOYMENT_ID__ === "undefined" ? "" : __PANDAS_DEPLOYMENT_ID__,
} as const;
